var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"expand":""},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v(" "+_vm._s(item.name)+" от "+_vm._s(_vm.$moment(item.created_at).format('LL'))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }